
import { MAINTENANCE_ASPECT_METADATA } from './maintenance-aspect.metadata';
import { MaintenanceAspect } from './maintenance-aspect.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class MaintenanceAspectEntityDecoratorBase extends GenericEntityDecorator<MaintenanceAspect, number> {
  constructor() {
    super(MAINTENANCE_ASPECT_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.aspectAssetId == null) {
      return null;
    }
    return parseInt(params.aspectAssetId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: MaintenanceAspect): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




